import { render, staticRenderFns } from "./AdminArchivos.vue?vue&type=template&id=2e5791a8&"
import script from "./AdminArchivos.vue?vue&type=script&lang=js&"
export * from "./AdminArchivos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports